import { type ReactElement } from "react";
import { Text, Card, EmptyState, Button } from "@citibox-panel/ui";

export function EmptyStateDemo(): ReactElement {
  return (
    <>
      <Text variant="body2" color="secondary" gutterBottom>
        Estado vacío transversal (icono opcional + título + descripción +
        acción).
      </Text>
      <Card variant="outlined" sx={{ maxWidth: 480 }}>
        <EmptyState
          title="Sin búsquedas abiertas"
          description="Empieza una búsqueda para ver la información del caso."
          action={<Button>Nueva búsqueda</Button>}
        />
      </Card>
    </>
  );
}
